module.exports = __webpack_public_path__ + "static/media/motorcycle.84382c6d.png";